import { gql } from '@zenbusiness/application-commons-graphql';

import { hashCode } from '#client/utils/text';

export const CreatePayeesPlaidMutationGQL = (fields = ['id']) => {
  let hash = 0;
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < fields.length; i++) {
    hash += hashCode(fields[i]);
  }
  hash = Math.abs(hash);
  const operationName = `createBankingPartnerCounterparty${hash}`;
  const gqlStr = `mutation ${operationName}($input: CreateBankingPartnerCounterpartyInput!) {
    createBankingPartnerCounterparty(input: $input) {
      status
      ${fields.join('\n ')}
    }
  }`;
  return gql(gqlStr);
};

export const RELINK_PLAID_MUTATION = gql`
  mutation relinkBankingPartnerCounterparty($input: RelinkPartnerAccountInput!) {
    relinkBankingPartnerCounterparty(input: $input) {
      status
      bankingCounterparty {
        bank
        accountNumber
      }
    }
  }
`;

export const UNLINK_PLAID_ACCOUNT_MUTATION = gql`
  mutation unlinkBankingPartnerCounterparty($input: UnlinkBankingPartnerCounterpartyInput!) {
    unlinkBankingPartnerCounterparty(input: $input) {
      status
      bankingCounterparty {
        bank
        accountNumber
      }
    }
  }
`;
